import styled from "styled-components";

import { layout } from "/styles";

export const TestResultsProviderNoteWrapper = styled.div(layout.marginVertical("gutter"));
